// The browser's own check before a result shows or is saved (Stage 2, 27 Oct 2026, the fixer's pass): every answer
// passes validateAnswer against its question, as the server's readSession checks it
// (supabase/functions/_shared/strategy/recompute.ts), so the browser never shows or sends a session the server refuses.
// An answer that no longer fits its question is cleared, with its history entries marked invalidated as editAnswer
// clears a dependent, so the tool asks it again. The case that needs it: C03 answered again with the same value moves
// its answer time past C04's, so a later change of C03 to "I am not sure yet" keeps C04's amount, which "not sure"
// doesn't take. Pure, so it's tested in Node (tests/strategy/server-parity.test.mjs).
import {validateAnswer} from './session.mjs';

// questionOf(id): the question an answer is checked against, as app.js's question() finds it
export function invalidAnswerIds(session,questionOf){
 return Object.keys(session.answers).filter(id=>{
  let q;try{q=questionOf(id);}catch{return true;}
  return !q||validateAnswer(q,session.answers[id],session.answers)!==null;
 });
}
export function clearAnswers(session,ids){
 if(!ids.length)return session;
 const n=structuredClone(session);
 for(const id of ids){delete n.answers[id];delete n.contexts[id];for(const h of n.history)if(h.id===id)h.state='invalidated';}
 n.revision++;return n;
}
